module.exports = __webpack_public_path__ + "static/media/XLV_Carousel.56d419b6.jpg";